module.exports = __webpack_public_path__ + "img/rsb.76b084b5.png";